import React, { useEffect, useState } from 'react';
import { Nav, Container, Notification, Avatar } from "tabler-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const MainActionsHeader = ({ openMainModal, toggleSidebar }) => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('tokens'));
    if (user) setUserData(user.admin);
  }, []);

  return (
    <div style={{
      position: 'sticky',
      top: 0,
      backgroundColor: 'white',
      padding: '12px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
      zIndex: 10,
      width: '100%'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <div 
          onClick={toggleSidebar} 
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          <FontAwesomeIcon icon={faBars} style={{ fontSize: '20px', color: '#333' }} />
        </div>

        <div className="main-header-nav-items">
           <Nav>
             <Nav.Item icon="plus" onClick={() => openMainModal('shipment-create')}>Shipment</Nav.Item>
             <Nav.Item icon="plus" onClick={() => openMainModal('user-create')}>User</Nav.Item>
             <Nav.Item icon="plus" onClick={() => openMainModal('product-create')}>Product</Nav.Item>
             <Nav.Item icon="plus" onClick={() => openMainModal('category-create')}>Category</Nav.Item>
           </Nav>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
        <Notification.Tray notificationsObjects={[]} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', borderLeft: '1px solid #eee', paddingLeft: '15px' }}>
          <Avatar imageURL={'https://react.semantic-ui.com/images/avatar/small/matthew.png'} size="md" />
          <div style={{ lineHeight: '1.2' }}>
            <b style={{ fontSize: '14px', display: 'block' }}>{userData?.firstName} {userData?.lastName}</b>
            <small style={{ color: '#888' }}>Administrator</small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainActionsHeader;